import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import './Navbar.css';

function Navbar() {
  const [isMobile, setIsMobile] = useState(false);
  const [isHomeDropdownOpen, setIsHomeDropdownOpen] = useState(false);
  const [isAboutDropdownOpen, setIsAboutDropdownOpen] = useState(false);

  const toggleMenu = () => {
    setIsMobile(!isMobile);
  };

  return (
    <nav className="navbar-container">
      {/* Top Section - Styled as Header */}
      <div className="navbar-header">
        {/* Left Logo */}
        <div className="navbar-logo">
          <NavLink to="/" className="navbar-brand">
            <img src="images/logo.jpg" alt="RDTC Singawal Driving Center" className="navbar-logo-image" />
          </NavLink>
        </div>

        {/* Centered Header Text */}
        <div className="header-text">
        <h2 className="english-text">REGIONAL DRIVING TRAINING CENTER, SINGAWAL Ajmer</h2>
          <p className="subtext">
            (A Joint Venture of Ministry of Road Transport & Highways - Govt. of India, Transport & Road Safety Department - Govt. of Rajasthan and Rajasthan Sadak Suraksha Society)
          </p>
          <h3 className="operated-by">OPERATED BY: VAHAN CHALAK KAUSHAL VIKAS SANSTHAN SINGAWAL</h3>
          <br />
          <h2 className="hindi-text">क्षेत्रीय चालन प्रशिक्षण केंद्र, सिंगावल अजमेर</h2>
          <p className="subtext">
            (सड़क परिवहन एवं राजमार्ग मंत्रालय - भारत सरकार, परिवहन एवं सड़क सुरक्षा विभाग - राजस्थान सरकार तथा राजस्थान सड़क सुरक्षा सोसायटी
              का संयुक्त उपक्रम)
          </p>
          <h3 className="operated-by">संचालन द्वारा: वाहन चालक कौशल विकास संस्थान सिंगावल</h3>
        </div>

        {/* Right Logo */}
        <div className="navbar-logo">
  <a href="http://rajasthanroadsafety.com/en/" target="_blank" rel="noopener noreferrer">
    <img src="/images/RSSS.jpg" alt="RDTC Singawal Driving Center" className="navbar-logo-image" />
  </a>
</div>

      </div>

      <div className={`navbar-links ${isMobile ? 'mobile-active' : ''}`}>
        {/* Home Dropdown */}
        <div
          className="navbar-dropdown"
          onMouseEnter={() => setIsHomeDropdownOpen(true)}
          onMouseLeave={() => setIsHomeDropdownOpen(false)}
        >
          <NavLink
            to="/"
            className={({ isActive }) => (isActive ? 'navbar-link active' : 'navbar-link')}
            style={{ color: 'black' }}
          >
            Home <span className="dropdown-icon">▼</span>
          </NavLink>
          {isHomeDropdownOpen && (
            <div className="dropdown-content">
              <NavLink
                to="/credentials"
                className={({ isActive }) => (isActive ? 'dropdown-link active' : 'dropdown-link')}
              >
                CredentialsPages
              </NavLink>
            </div>
          )}
        </div>

        {/* About Us Dropdown */}
        <div
          className="navbar-dropdown"
          onMouseEnter={() => setIsAboutDropdownOpen(true)}
          onMouseLeave={() => setIsAboutDropdownOpen(false)}
        >
          <NavLink
            to="/about"
            className={({ isActive }) => (isActive ? 'navbar-link active' : 'navbar-link')}
            style={{ color: 'black' }}
          >
          About Us <span className="dropdown-icon">▼</span>
          </NavLink>
          {isAboutDropdownOpen && (
            <div className="dropdown-content">
              <NavLink
                to="/about"
                className={({ isActive }) => (isActive ? 'dropdown-link active' : 'dropdown-link')}
              >
                About Us
              </NavLink>
              <NavLink
                to="/key-activities"
                className={({ isActive }) => (isActive ? 'dropdown-link active' : 'dropdown-link')}
              >
                Activities
              </NavLink>
              <NavLink
                to="/drivingtrackpage"
                className={({ isActive }) => (isActive ? 'dropdown-link active' : 'dropdown-link')}
              >
                Driving Tracks
              </NavLink>
              <NavLink
                to="/gallery"
                className={({ isActive }) => (isActive ? 'dropdown-link active' : 'dropdown-link')}
              >
                Gallery
              </NavLink>
            </div>
          )}
        </div>

        <NavLink
          to="/administration"
          className={({ isActive }) => (isActive ? 'navbar-link active' : 'navbar-link')}
          style={{ color: 'black' }}
        >
          Administration
        </NavLink>

        <NavLink
          to="/appointment"
          className={({ isActive }) => (isActive ? 'navbar-link active' : 'navbar-link')}
          style={{ color: 'black' }}
        >
          Appointment
        </NavLink>

        <NavLink
          to="/contact"
          className={({ isActive }) => (isActive ? 'navbar-link active' : 'navbar-link')}
          style={{ color: 'black' }}
        >
          Contact
        </NavLink>
      </div>

      <div className="hamburger" onClick={toggleMenu}>
        ☰
      </div>
    </nav>
  );
}

export default Navbar;
